const LeadsActionTypes = {
  /** ***************** ADD LEADS DETAILS START *********************** */
  ADD_LEADS_DETAILS_START: "add_leads_details_start",
  ADD_LEADS_DETAILS_SUCCESS: "add_leads_details_success",
  ADD_LEADS_DETAILS_FAILURE: "add_leads_details_failure",
  ADD_LEADS_DETAILS_RESPONSE_RESET: "add_leads_details_response_reset",
  ADD_LEADS_DETAILS_RESPONSE_CHANGED: "add_leads_details_response_changed",
  /** ***************** ADD LEADS DETAILS END *********************** */

  /** ***************** UPDATE LEADS DETAILS START *********************** */
  UPDATE_LEADS_DETAILS_START: "update_leads_details_start",
  UPDATE_LEADS_DETAILS_SUCCESS: "update_leads_details_success",
  UPDATE_LEADS_DETAILS_FAILURE: "update_leads_details_failure",
  UPDATE_LEADS_DETAILS_RESPONSE_RESET: "update_leads_details_response_reset",
  UPDATE_LEADS_DETAILS_RESPONSE_CHANGED:
    "update_leads_details_response_changed",
  /** ***************** UPDATE LEADS DETAILS END *********************** */

  /** ***************** GET LEADS DETAILS START *********************** */
  GET_LEADS_LIST_START: "get_leads_list_start",
  GET_LEADS_LIST_SUCCESS: "get_leads_list_success",
  GET_LEADS_LIST_FAILURE: "get_leads_list_failure",
  GET_LEADS_LIST_RESPONSE_RESET: "get_leads_list_response_reset",
  GET_LEADS_LIST_RESPONSE_CHANGED: "get_leads_list_response_changed",
  /** ***************** GET LEADS DETAILS END *********************** */

  /** ***************** FETCH LEADS DETAILS START *********************** */
  FETCH_LEADS_DETAILS_START: "fetch_leads_details_start",
  FETCH_LEADS_DETAILS_SUCCESS: "fetch_leads_details_success",
  FETCH_LEADS_DETAILS_FAILURE: "fetch_leads_details_failure",
  FETCH_LEADS_DETAILS_RESPONSE_RESET: "fetch_leads_details_response_reset",
  FETCH_LEADS_DETAILS_RESPONSE_CHANGED: "fetch_leads_details_response_changed",
  /** ***************** FETCH LEADS DETAILS START *********************** */

  /** ***************** DELETE LEADS DETAILS START *********************** */
  DELETE_LEADS_DETAILS_START: "delete_leads_details_start",
  DELETE_LEADS_DETAILS_SUCCESS: "delete_leads_details_success",
  DELETE_LEADS_DETAILS_FAILURE: "delete_leads_details_failure",
  DELETE_LEADS_DETAILS_RESPONSE_RESET: "delete_leads_details_response_reset",
  DELETE_LEADS_DETAILS_RESPONSE_CHANGED:
    "delete_leads_details_response_changed",
  /** ***************** DELETE LEADS DETAILS END *********************** */

  /** ***************** STATUS LIST DETAILS START *********************** */
  STATUS_LIST_DETAILS_START: "status_list_details_start",
  STATUS_LIST_DETAILS_SUCCESS: "status_list_details_success",
  STATUS_LIST_DETAILS_FAILURE: "status_list_details_failure",
  STATUS_LIST_DETAILS_RESPONSE_RESET: "status_list_details_response_reset",
  STATUS_LIST_DETAILS_RESPONSE_CHANGED: "status_list_details_response_changed",
  /** ***************** STATUS LIST  DETAILS END *********************** */

  /*****************  GET PRODUCT LIST START  *******************/
  GET_PRODUCT_DROPDOWN_LIST_START: "get_product_dropdown_list_start",
  GET_PRODUCT_DROPDOWN_LIST_SUCCESS: "get_product_dropdown_list_success",
  GET_PRODUCT_DROPDOWN_LIST_FAILURE: "get_product_dropdown_list_failure",
  GET_PRODUCT_DROPDOWN_LIST_RESPONSE_RESET:
    "get_product_dropdown_list_response_reset",
  GET_PRODUCT_DROPDOWN_LIST_RESPONSE_CHANGED:
    "get_product__dropdown_list_response_changed",
  /*****************  GET PRODUCT LIST END  *******************/

  /*****************  GET LEADSOURCE LIST START  *******************/
  GET_LEADSOURCE_DROPDOWN_LIST_START: "get_leadsource_dropdown_list_start",
  GET_LEADSOURCE_DROPDOWN_LIST_SUCCESS: "get_leadsource_dropdown_list_success",
  GET_LEADSOURCE_DROPDOWN_LIST_FAILURE: "get_leadsource_dropdown_list_failure",
  GET_LEADSOURCE_DROPDOWN_LIST_RESPONSE_RESET:
    "get_leadsource_dropdown_list_response_reset",
  GET_LEADSOURCE_DROPDOWN_LIST_RESPONSE_CHANGED:
    "get_leadsource__dropdown_list_response_changed",
  /*****************  GET LEADSOURCE LIST END  *******************/

  /*****************  GET LEADS_PRODUCT LIST START  *******************/
  GET_DOCUMENTDROPDOWN_LIST_START: "get_leadsource_dropdown_list_start",
  GET_DOCUMENTDROPDOWN_LIST_SUCCESS: "get_leadsource_dropdown_list_success",
  GET_DOCUMENTDROPDOWN_LIST_FAILURE: "get_leadsource_dropdown_list_failure",
  GET_DOCUMENTDROPDOWN_LIST_RESPONSE_RESET:
    "get_leadsource_dropdown_list_response_reset",
  GET_DOCUMENTDROPDOWN_LIST_RESPONSE_CHANGED:
    "get_leadsource__dropdown_list_response_changed",
  /*****************  GET LEADS_PRODUCT LIST END  *******************/

  /** *****************SEARCH PRELEAD LIMIT START *********************** */
  SEARCH_PRELEAD_LIMIT_DETAILS_START: "search_prelead_Limit_details_start",
  SEARCH_PRELEAD_LIMIT_DETAILS_SUCCESS: "search_prelead_Limit_details_success",
  SEARCH_PRELEAD_LIMIT_DETAILS_FAILURE: "search_prelead_Limit_details_failure",
  SEARCH_PRELEAD_LIMIT_DETAILS_RESPONSE_RESET:
    "search_prelead_Limit_details_response_reset",
  SEARCH_PRELEAD_LIMIT_DETAILS_RESPONSE_CHANGED:
    "search_prelead_Limit_details_response_changed",
  /** ***************** SEARCH PRELEAD LIMIT  END *********************** */

  /** ***************** FETCH LEADS PRODUCT DETAILS START *********************** */
  FETCH_DOCUMENT_DETAILS_START: "fetch_document_details_start",
  FETCH_DOCUMENT_SUCCESS: "fetch_document_details_success",
  FETCH_DOCUMENT_FAILURE: "fetch_document_details_failure",
  FETCH_DOCUMENT_RESPONSE_RESET: "fetch_document_details_response_reset",
  FETCH_DOCUMENT_RESPONSE_CHANGED: "fetch_document_details_response_changed",
  /** ***************** FETCH LEADS PRODUCT DETAILS START *********************** */

  /*****************  FETCH PRODUCT DETAILS START  *******************/
  CREATE_DOCUMENT_DETAILS_START: "create_document_details_start",
  CREATE_DOCUMENT_DETAILS_SUCCESS: "create_document_details_success",
  CREATE_DOCUMENT_DETAILS_FAILURE: "create_document_details_failure",
  CREATE_DOCUMENT_DETAILS_RESPONSE_RESET:
    "create_document_details_response_reset",
  CREATE_DOCUMENT_DETAILS_RESPONSE_CHANGED:
    "create_document_details_response_changed",
  /*****************  FETCH PRODUCT DETAILS END  *******************/

  LOAN_APPLIED_DETAILS_START: "LOAN_APPLIED_DETAILS_START",
  LOAN_APPLIED_DETAILS_SUCCESS: "LOAN_APPLIED_DETAILS_SUCCESS",
  LOAN_APPLIED_DETAILS_FAILURE: "LOAN_APPLIED_DETAILS_FAILURE",
  LOAN_APPLIED_DETAILS_RESET: "LOAN_APPLIED_DETAILS_RESET",
  LOAN_APPLIED_DETAILS_CHANGE: "LOAN_APPLIED_DETAILS_CHANGE",

  /*****************  FETCH LEAD APPLIED LOG DETAILS START  *******************/
  LEAD_APPLIED_LOG_LIST_FETCH_START: "lead_applied_log_list_fetch_start",
  LEAD_APPLIED_LOG_LIST_FETCH_SUCCESS: "lead_applied_log_list_fetch_success",
  LEAD_APPLIED_LOG_LIST_FETCH_FAILURE: "lead_applied_log_list_fetch_failure",
  LEAD_APPLIED_LOG_LIST_RESPONSE_RESET_START:
    "lead_applied_log_list_response_reset_start",
  LEAD_APPLIED_LOG_LIST_FETCH_RESPONSE_CHANGED:
    "lead_applied_log_list_fetch_response_changed",
  /** Clear cached loan log rows (e.g. when switching leads) without starting a fetch */
  LEAD_APPLIED_LOG_LIST_CLEAR: "lead_applied_log_list_clear",
  /*****************  FETCH LEAD APPLIED LOG DETAILS  END  *******************/

  /*****************  FETCH SALE APPLIED LOG DETAILS START  *******************/
  SALE_APPLIED_LOG_LIST_FETCH_START: "sale_applied_log_list_fetch_start",
  SALE_APPLIED_LOG_LIST_FETCH_SUCCESS: "sale_applied_log_list_fetch_success",
  SALE_APPLIED_LOG_LIST_FETCH_FAILURE: "sale_applied_log_list_fetch_failure",
  SALE_APPLIED_LOG_LIST_RESPONSE_RESET_START:
    "sale_applied_log_list_response_reset_start",
  SALE_APPLIED_LOG_LIST_FETCH_RESPONSE_CHANGED:
    "sale_applied_log_list_fetch_response_changed",
  /*****************  FETCH SALE APPLIED LOG DETAILS  END  *******************/

  /** ***************** UPDATE LEADS DOCUMENT  DETAILS START *********************** */
  UPDATE_LEADS_DOC_DETAILS_START: "update_leads_doc_details_start",
  UPDATE_LEADS_DOC_DETAILS_SUCCESS: "update_leads_doc_details_success",
  UPDATE_LEADS_DOC_DETAILS_FAILURE: "update_leads_doc_details_failure",
  UPDATE_LEADS_DOC_DETAILS_RESPONSE_RESET:
    "update_leads_doc_details_response_reset",
  UPDATE_LEADS_DOC_DETAILS_RESPONSE_CHANGED:
    "update_leads_doc_details_response_changed",
  /** ***************** UPDATE LEADS DOCUMENT  DETAILS END *********************** */

  /** ***************** GET LEADS DOCUMENT  DETAILS START *********************** */
  GET_LEADS_DOC_LIST_START: "get_leads_doc_list_start",
  GET_LEADS_DOC_LIST_SUCCESS: "get_leads_doc_list_success",
  GET_LEADS_DOC_LIST_FAILURE: "get_leads_doc_list_failure",
  GET_LEADS_DOC_LIST_RESPONSE_RESET: "get_leads_doc_list_response_reset",
  GET_LEADS_DOC_LIST_RESPONSE_CHANGED: "get_leads_doc_list_response_changed",
  /** ***************** GET LEADS DOCUMENT  DETAILS END *********************** */

  /** ***************** FETCH LEADS DOCUMENT  DETAILS START *********************** */
  FETCH_LEADS_DOC_DETAILS_START: "fetch_leads_doc_details_start",
  FETCH_LEADS_DOC_DETAILS_SUCCESS: "fetch_leads_doc_details_success",
  FETCH_LEADS_DOC_DETAILS_FAILURE: "fetch_leads_doc_details_failure",
  FETCH_LEADS_DOC_DETAILS_RESPONSE_RESET:
    "fetch_leads_doc_details_response_reset",
  FETCH_LEADS_DOC_DETAILS_RESPONSE_CHANGED:
    "fetch_leads_doc_details_response_changed",
  /** ***************** FETCH LEADS DOCUMENT  DETAILS START *********************** */

  /** ***************** DELETE LEADS DOCUMENT  DETAILS START *********************** */
  DELETE_LEADS_DOC_DETAILS_START: "delete_leads_doc_details_start",
  DELETE_LEADS_DOC_DETAILS_SUCCESS: "delete_leads_doc_details_success",
  DELETE_LEADS_DOC_DETAILS_FAILURE: "delete_leads_doc_details_failure",
  DELETE_LEADS_DOC_DETAILS_RESPONSE_RESET:
    "delete_leads_doc_details_response_reset",
  DELETE_LEADS_DOC_DETAILS_RESPONSE_CHANGED:
    "delete_leads_doc_details_response_changed",

  /***************** GET LEAD APPLIED  LIST START  *******************/
  GET_LEAD_APPLIED_LIST_START: "get_lead_applied_list_start",
  GET_LEAD_APPLIED_LIST_SUCCESS: "get_lead_applied_list_success",
  GET_LEAD_APPLIED_LIST_FAILURE: "get_lead_applied_list_failure",
  GET_LEAD_APPLIED_LIST_RESPONSE_RESET: "get_lead_applied_list_response_reset",
  GET_LEAD_APPLIED_LIST_RESPONSE_CHANGED:
    "get_lead_applied_list_response_changed",
  /*****************  GET LEAD APPLIED  LIST END  *******************/

  /*****************  FETCH SIC DETAILS START  *******************/
  FETCH_SIC_DETAILS_START: "fetch_sic_details_start",
  FETCH_SIC_DETAILS_SUCCESS: "fetch_sic_details_success",
  FETCH_SIC_DETAILS_FAILURE: "fetch_sic_details_failure",
  FETCH_SIC_DETAILS_RESPONSE_RESET: "fetch_sic_details_response_reset",
  FETCH_SIC_DETAILS_RESPONSE_CHANGED: "fetch_sic_details_response_changed",
  /*****************  FETCH SIC DETAILS END  *******************/

  /** ***************** ADD STATUS DETAILS START *********************** */
  ADD_STATUS_DETAILS_START: "add_status_details_start",
  ADD_STATUS_DETAILS_SUCCESS: "add_status_details_success",
  ADD_STATUS_DETAILS_FAILURE: "add_status_details_failure",
  ADD_STATUS_DETAILS_RESPONSE_RESET: "add_status_details_response_reset",
  ADD_STATUS_DETAILS_RESPONSE_CHANGED: "add_status_details_response_changed",
  /** ***************** ADD STATUS DETAILS END *********************** */

  /** ***************** UPDATE STATUS DETAILS START *********************** */
  UPDATE_STATUS_DETAILS_START: "update_status_details_start",
  UPDATE_STATUS_DETAILS_SUCCESS: "update_status_details_success",
  UPDATE_STATUS_DETAILS_FAILURE: "update_status_details_failure",
  UPDATE_STATUS_DETAILS_RESPONSE_RESET: "update_status_details_response_reset",
  UPDATE_STATUS_DETAILS_RESPONSE_CHANGED:
    "update_status_details_response_changed",
  /** ***************** UPDATE STATUS DETAILS END *********************** */

  /*****************  DELETE LENDER APPLIED DETAILS START  *******************/
  DELETE_LENDER_APPLIED_DETAILS_START: "delete_lender_applied_details_start",
  DELETE_LENDER_APPLIED_DETAILS_SUCCESS: "delete_lender_applied_details_success",
  DELETE_LENDER_APPLIED_DETAILS_FAILURE: "delete_lender_applied_details_failure",
  DELETE_LENDER_APPLIED_DETAILS_RESPONSE_RESET:
    "delete_lender_applied_details_response_reset",
  DELETE_LENDER_APPLIED_DETAILS_RESPONSE_CHANGED:
    "delete_lender_applied_details_response_changed",
  /*****************  DELETE LENDER APPLIED DETAILS END  *******************/
  /*****************  DELETE LENDER APPLIED DETAILS END  *******************/

  /** ***************** SEARCH DASHBOARD LEADS START *********************** */
  SEARCH_DASHBOARD_LEADS_START: "search_dashboard_leads_start",
  SEARCH_DASHBOARD_LEADS_SUCCESS: "search_dashboard_leads_success",
  SEARCH_DASHBOARD_LEADS_FAILURE: "search_dashboard_leads_failure",
  SEARCH_DASHBOARD_LEADS_RESPONSE_RESET:
    "SEARCH_DASHBOARD_LEADS_RESPONSE_RESET",
  SEARCH_DASHBOARD_LEADS_RESPONSE_CHANGED:
    "SEARCH_DASHBOARD_LEADS_RESPONSE_CHANGED",

  DELETE_DASHBOARD_LEADS_START: "DELETE_DASHBOARD_LEADS_START",
  DELETE_DASHBOARD_LEADS_SUCCESS: "DELETE_DASHBOARD_LEADS_SUCCESS",
  DELETE_DASHBOARD_LEADS_FAILURE: "DELETE_DASHBOARD_LEADS_FAILURE",
  DELETE_DASHBOARD_LEADS_RESPONSE_RESET:
    "DELETE_DASHBOARD_LEADS_RESPONSE_RESET",

  EXPORT_DASHBOARD_LEADS_START: "EXPORT_DASHBOARD_LEADS_START",
  EXPORT_DASHBOARD_LEADS_SUCCESS: "EXPORT_DASHBOARD_LEADS_SUCCESS",
  EXPORT_DASHBOARD_LEADS_FAILURE: "EXPORT_DASHBOARD_LEADS_FAILURE",
  EXPORT_DASHBOARD_LEADS_RESPONSE_RESET:
    "EXPORT_DASHBOARD_LEADS_RESPONSE_RESET",
  /** ***************** SEARCH DASHBOARD LEADS END *********************** */
};

export default LeadsActionTypes;
